<template>
	<div class="log-schedule-update-component">
		<div class="log-schedule-update-component-table-ctrls mb-4">
			<div class="filter-table__input-wrap search-control">
				<input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

			<filter-component :filters="filter" @filterApplied="handleFilterData" />

			<a style="margin-left: auto;" v-if="this.tbody.length > 0" class="btn brn-primary-fit" @click="showExportModal">Экспорт</a>
		</div>

		<table class="service-table table align-middle">
			<thead>
				<tr>
					<th scope="col" v-for="(elem, index) in thead" :key="index">
						<div style="display: flex; gap: 4px; align-items: center; justify-content: center;" class="th-inner sortable asc">
							<span style="width: 95%;">{{ elem }}</span>
							<div class="dropdown">
								<svg v-if="!['Описание статуса', 'Версия'].includes(elem)" @click="toggleDropdown(index)"
									style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 7.5L10 12.5L15 7.5" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<div class="dropdown-menu" :class="{ 'show': dropdownVisible[index] }">
									<a class="dropdown-item" href="#" @click.prevent="sortBy('asc', elem)">По возрастанию</a>
									<a class="dropdown-item" href="#" @click.prevent="sortBy('desc', elem)">По убыванию</a>
								</div>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in tbody" :key="row.id">
					<td>
						<div class="marker marker_16px"
							:style="{ backgroundColor : row.tbody.status_color }">
						</div>
					</td>
                    <td>{{ row.tbody.status_description }}</td>
                    <td>{{ row.tbody.version_number }}</td>
					<td>
						<div class="date-time-col">
							<span>{{ row.tbody.download_date_time }}</span>
						</div>
					</td>
					<td>{{ row.tbody.client }}</td>
					<td>{{ row.tbody.brand }}</td>
					<td>{{ row.tbody.location_number }}</td>
					<td>{{ row.tbody.device_type }}</td>
					<td>{{ row.tbody.device_ip }}</td>
					<td>{{ row.tbody.software }}</td>
					<td class="w-25 text-break">{{ row.tbody.message }}</td>
				</tr>
			</tbody>
		</table>
	</div>

	<Transition name="fade">
		<div>
            <ExportModal
                v-if="exportModal"
                :filters="filter"
                :file-name="'Логи загрузка обновлений'"
                :route-export="route_export"
                :route-check-data-before-export="route_check_data_before_export"
            />
        </div>
    </Transition>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import ExportModal from '../../../../modals/ExportModal.vue';
import { mapState, mapMutations } from 'vuex/dist/vuex.cjs.js';
import ChangePage from '../../../../helpers/ChangePage';
import PaginationElement from '../../../../elements/PaginationElement.vue';
import { dateFormat } from '../../../../utilites';
import LogDownloadUpdatesModel from '../../../../models/LogDownloadUpdatesModel';

export default {
    name: 'LogDownloadsUpdatesComponent',

	components: { PaginationElement, ExportModal },

    props: {
        route_list: String,
        route_brands_list: String,
        route_clients: String,
        route_get_names_devices_types: String,
        route_versions: String,
        route_export: String,
        route_check_data_before_export: String
    },

	data() {
		return {
            model: new LogDownloadUpdatesModel({
                route_list: this.route_list,
                route_client_search: this.route_clients,
            }),
			thead: [
                '',
                'Статус',
                'Версия',
                'Дата и время',
                'Клиент',
                'Бренд',
                'Номер аптеки',
                'Тип устройства',
                'IP',
                'ПО',
                'Сообщение'
            ],
			tbody: [],

			currentSortColumn: '',
			currentSortOrder: '',
			dropdownVisible: Array(9).fill(false),

			selectedRows: [],
			selectAll: false,

            date: null,
            dateFormat: '',

            search: '',

            brand: null,
            brands: [],
            selectedBrand: null,

            client: null,
            clients: [],
            selectedClient: null,

            deviceType: null,
            deviceTypes: [],
            selectedDeviceType: null,

            version: null,
            versions: [],
            selectedVersion: null,

            count: 1,
            limit: 30,
            page: 1,
		}
	},

	computed: {
		...mapState('filterComponent', ['filterState']),
		...mapState('logs', ['exportModal']),

		filter() {
			return [
                {
                    type: 'select',
                    name: 'Бренд',
                    key: 'brand',
                    model: this.brand,
                    options: this.brands,
                    title: 'name'
                },
                {
                    type: 'select',
                    name: 'Клиент',
                    key: 'client',
                    model: this.client,
                    options: this.clients,
                    title: 'name'
                },
                {
                    type: 'select',
                    name: 'Тип устройства',
                    key: 'device_type',
                    model: this.deviceType,
                    options: this.deviceTypes,
                    title: 'name'
                },
                {
                    type: 'select',
                    name: 'Версия',
                    key: 'version',
                    model: this.version,
                    options: this.versions,
                    title: 'number'
                },
                {
                    type: 'date',
                    name: 'Дата',
                    key: 'date',
                    model: this.date
                },
			]
		}
	},

	methods: {
		...mapMutations('filterComponent', ['clearFilterState']),
		...mapMutations('logs', ['showExportModal']),

		sortBy(order, column) {
			this.currentSortColumn = this.columnMap[column];
			this.currentSortOrder = order;
			this.loadTable();
		},
        toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdownVisible = this.dropdownVisible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },
        closeDropdown(event) {
            let clickOutside = event.target.className !== 'dropdown-item';
            let dropDownOpenned = document.querySelector('.show') !== null;
            if (dropDownOpenned && clickOutside) {
                this.dropdownVisible = this.dropdownVisible.map(() => false);
            };
        },
		toggleSelectAll() {
			if (this.selectAll) {
				this.selectedRows = this.tbody.map(row => row.id);
			} else {
				this.selectedRows = [];
			}
		},
        loadTable: async function () {
            let response = await this.model.loadTable(
                this.page,
                this.limit,
                this.search,
                this.brand,
                this.client,
                this.deviceType,
                this.selectedSoftware,
                this.version,
                this.date,
                this.currentSortColumn,
                this.currentSortOrder
            );
            this.tbody = response.tbody;
            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
        getBrands: async function () {
            let data = await axios.get(this.route_brands_list);
            this.brands = data.data.items;
        },
        getClients: async function () {
            let clients = await this.model.clients();
            this.clients = clients.items;
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types);
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        getVersions: async function () {
            let data = await axios.get(this.route_versions, {
                params: {
                    limit: 9999,
                    currentSortColumn: '',
                    currentSortOrder: ''
                }
            });

            let versionsArray = data.data.items;

            for (const key in versionsArray) {
                this.versions[key] = {
                    id: versionsArray[key].id,
                    number: versionsArray[key].full_number
                }
            }
        },
        onSearch: async function () {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() == '') {
                this.page = 1;
                await this.loadTable();
            }
        },
        handleFilterData(data) {
            this.brand = data.selectedBrand ?? null;
            this.client = data.selectedClient ?? null;
            this.deviceType = data.selectedDeviceType ?? null;
            this.version = data.selectedVersion ?? null;
            // Оно меняло computed filter, может еще понадобится
            this.date = data.date ?? null;

            this.loadTable();
        },
        pageChange: async function (page) {
            this.page = page;
            await this.loadTable();
        },
	},

	watch: {
		selectedRows(newSelectedRows) {
			this.selectAll = newSelectedRows.length === this.tbody.length;
		}
	},

	mounted() {
		document.addEventListener('click', this.closeDropdown);
		this.clearFilterState();
        this.loadTable();
        this.getBrands();
        this.getClients();
        this.getDevicesTypesName();
        this.getVersions();
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.page-label {
		font-size: 18px;
		font-weight: 600;
	}

	.date-time-col {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.log-schedule-update-component-table-ctrls {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 20px;
	}

	.v-selects {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}

	.dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-item {
        font-size: 14px;
    }

    .dropdown-menu {
        padding: 0;
        position: absolute;
        min-width: 160px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
        z-index: 1;
    }

    .dropdown-menu a {
        color: black;
        padding: 8px 12px;
        text-decoration: none;
        display: block;
    }

    .dropdown-menu a:hover {
        background-color: #F1F7FF;
    }
</style>
